import buildUrl from 'modules/core/lib/buildUrl'
import users from 'modules/core/store/collections/users'

export const getMemberAvatars = (ownerAccessIds: number[]) => {
  const members = users.filter((user) => ownerAccessIds.includes(user.id))

  const avatarStack = members.map((member) => {
    return {
      label: member.fullName(),
      url: buildUrl(member.avatar_full),
    }
  })

  return avatarStack
}
